import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';
import { useState, useCallback, memo } from 'react';
import {
  Brain,
  Menu,
  X,
  Target,
  Play,
  Sparkles,
  BookOpen,
  HelpCircle,
  BarChart,
  Users2,
  LogIn
} from 'lucide-react';
import './Navigation.css';

function Navigation() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = useCallback(() => {
    setIsMobileMenuOpen(prev => !prev);
  }, []);

  const closeMobileMenu = useCallback(() => {
    setIsMobileMenuOpen(false);
  }, []);

  return (
    <>
      {/* Navigation */}
      <nav className="navigation" role="navigation" aria-label="Main navigation">
        <div className="navigation__container">
          <div className="navigation__content">
            <Link to="/" className="navigation__logo" aria-label="EduExpertAI home page">
              <div className="navigation__logo-icon">
                <img
                  src="https://cdn.builder.io/api/v1/image/assets%2Fcb522452d2cb4e54b67e5d1f1223d5b8%2F9f8d6ab53c014f09bf7cbca2b0623a58?format=webp&width=800"
                  alt="EduExpertAI Logo"
                  crossOrigin="anonymous"
                  className="w-8 h-8"
                  aria-hidden="true"
                  loading="lazy"
                  decoding="async"
                />
              </div>
              <span className="navigation__logo-text">EduExpertAI</span>
            </Link>

            <div className="navigation__desktop-menu">
              <a href="#features" className="navigation__link">
                Features
              </a>
              <a href="#how-it-works" className="navigation__link">
                How it Works
              </a>
              {/* <Link to="/alumniconnect" className="navigation__link">
                🎓 Alumni Connect
              </Link> */}
              {/* <Link to="/demo" className="navigation__link">
                Try Demo
              </Link> */}
              {/* <Link to="/test-portal" className="navigation__link">
                🧪 Test Portal
              </Link> */}
              {/* <Link to="/question-test" className="navigation__link">
                Question Test
              </Link> */}
              {/* <Link to="/qgenerator" className="navigation__link">
                Q Generator
              </Link> */}
              {/* <a href="#pricing" className="navigation__link">
                Pricing
              </a> */}
            </div>

            {/* Mobile menu button */}
            <div className="navigation__mobile-toggle">
              <Link to="/login">
                <Button variant="outline" size="sm" className='dark:text-white'>
                  Login
                </Button>
              </Link>
              
              <Button
                variant="outline"
                size="sm"
                onClick={toggleMobileMenu}
                className="p-2"
                aria-label={isMobileMenuOpen ? 'Close mobile menu' : 'Open mobile menu'}
                aria-expanded={isMobileMenuOpen}
              >
                {isMobileMenuOpen ? (
                  <X className="w-6 h-6 dark:text-white" aria-hidden="true" />
                ) : (
                  <Menu className="w-6 h-6 dark:text-white" aria-hidden="true" />
                )}
              </Button>
            </div>

            <div className="navigation__desktop-actions">
              {/* <Link to="/interactive/join">
                <Button variant="ghost" size="sm" className='dark:text-white'>
                  Join Session
                </Button>
              </Link> */}
              <Link to="/login">
                <Button variant="outline" size="sm" className='dark:text-white'>
                  Login
                </Button>
              </Link>
              <Link to="/signup">
                <Button className="navigation__signup-btn">Sign Up</Button>
              </Link>
            </div>
          </div>
        </div>
      </nav>

      {/* Mobile Navigation Sidebar */}
      {isMobileMenuOpen && (
        <>
          {/* Backdrop */}
          <div className="navigation__backdrop" onClick={closeMobileMenu} />

          {/* Sidebar */}
          <div
            className="navigation__sidebar"
            role="dialog"
            aria-modal="true"
            aria-label="Mobile navigation menu"
          >
            <div className="navigation__sidebar-content">
              {/* Header */}
              <div className="navigation__sidebar-header">
                <Link
                  to="/"
                  className="navigation__logo"
                  onClick={closeMobileMenu}
                  aria-label="EduExpertAI home page"
                >
                  <div className="navigation__logo-icon">
                    <Brain className="w-5 h-5 text-white" />
                  </div>
                  <span className="navigation__logo-text">EduExpertAI</span>
                </Link>
                <Button
                  variant="ghost"
                  size="sm"
                  onClick={closeMobileMenu}
                  className="p-2"
                  aria-label="Close mobile menu"
                >
                  <X className="w-6 h-6" aria-hidden="true" />
                </Button>
              </div>

              {/* Navigation Links */}
              <nav
                className="navigation__sidebar-nav"
                role="navigation"
                aria-label="Mobile menu links"
              >
                <div className="navigation__sidebar-links">
                  <a
                    href="#features"
                    className="navigation__sidebar-link"
                    onClick={closeMobileMenu}
                  >
                    <div className="navigation__sidebar-link-content">
                      <Sparkles className="w-5 h-5" />
                      <span>Features</span>
                    </div>
                  </a>

                  <a
                    href="#how-it-works"
                    className="navigation__sidebar-link"
                    onClick={closeMobileMenu}
                  >
                    <div className="navigation__sidebar-link-content">
                      <Target className="w-5 h-5" />
                      <span>How it Works</span>
                    </div>
                  </a>

                  {/* <Link
                    to="/alumniconnect"
                    className="navigation__sidebar-link"
                    onClick={closeMobileMenu}
                  >
                    <div className="navigation__sidebar-link-content">
                      <Users2 className="w-5 h-5" />
                      <span>🎓 Alumni Connect</span>
                    </div>
                  </Link> */}

                  {/* <Link
                    to="/qgenerator"
                    className="navigation__sidebar-link"
                    onClick={closeMobileMenu}
                  >
                    <div className="navigation__sidebar-link-content">
                      <BookOpen className="w-5 h-5" />
                      <span>Q Generator</span>
                    </div>
                  </Link> */}

                </div>
              </nav>

              {/* Action Buttons */}
              <div className="navigation__sidebar-actions">
                {/* <Link to="/interactive/join" onClick={closeMobileMenu}>
                  <Button variant="outline" className="w-full justify-center">
                    Join Session
                  </Button>
                </Link> */}
                <Link to="/login" onClick={closeMobileMenu}>
                  <Button variant="secondary" className="w-full justify-center navigation__login-btn">
                    <LogIn className="w-4 h-4 mr-2" />
                    Login
                  </Button>
                </Link>
                <Link to="/signup" onClick={closeMobileMenu}>
                  <Button className="navigation__signup-btn w-full justify-center">Sign Up</Button>
                </Link>
                <div className="navigation__sidebar-footer-spacer" />
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
}

export default memo(Navigation);
